import { TGetSuggestResponse_1 } from '../../repositories/newbuilding-promos/v1/get-suggest';
import { ITypedReduxAction } from '../../types/redux/actionType';
import { actionGenerator } from '../../utils/redux/actionGenerator';

export enum ESuggestionsActionTypes {
  Request = 'SUGGESTIONS/REQUEST',
  Success = 'SUGGESTIONS/SUCCESS',
  Failure = 'SUGGESTIONS/FAILURE',
  Reset = 'SUGGESTIONS/RESET',
}

export type TSuggestionsSuccess = ITypedReduxAction<ESuggestionsActionTypes.Success, TGetSuggestResponse_1>;
export type TSuggestionsRequest = ITypedReduxAction<ESuggestionsActionTypes.Request>;
export type TSuggestionsFailure = ITypedReduxAction<ESuggestionsActionTypes.Failure>;
export type TSuggestionsReset = ITypedReduxAction<ESuggestionsActionTypes.Reset>;

/**
 * Redux action, который записывает в store список саджестов
 * @param promos TGetSuggestResponse_1
 */
export const suggestionsSuccess: (suggestResponse: TGetSuggestResponse_1) => TSuggestionsSuccess = actionGenerator<
  ESuggestionsActionTypes.Success,
  TGetSuggestResponse_1
>(ESuggestionsActionTypes.Success);

export const suggestionsRequest: () => TSuggestionsRequest = actionGenerator<ESuggestionsActionTypes.Request>(
  ESuggestionsActionTypes.Request,
);

export const suggestionsFailure: () => TSuggestionsFailure = actionGenerator<ESuggestionsActionTypes.Failure>(
  ESuggestionsActionTypes.Failure,
);

export const suggestionsReset: () => TSuggestionsReset = actionGenerator<ESuggestionsActionTypes.Reset>(
  ESuggestionsActionTypes.Reset,
);

export type TSuggestionsAction = TSuggestionsRequest | TSuggestionsSuccess | TSuggestionsFailure | TSuggestionsReset;
